module.exports = __webpack_public_path__ + "img/plazaradio.0a9f7da4.png";